import { render, staticRenderFns } from "./vipPrice.vue?vue&type=template&id=d44c505e&scoped=true&"
import script from "./vipPrice.vue?vue&type=script&lang=js&"
export * from "./vipPrice.vue?vue&type=script&lang=js&"
import style0 from "./vipPrice.vue?vue&type=style&index=0&id=d44c505e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44c505e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d44c505e')) {
      api.createRecord('d44c505e', component.options)
    } else {
      api.reload('d44c505e', component.options)
    }
    module.hot.accept("./vipPrice.vue?vue&type=template&id=d44c505e&scoped=true&", function () {
      api.rerender('d44c505e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/vipPrice.vue"
export default component.exports